
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Host {
  id: string;
  name: string;
  avatar?: string;
  super_host: boolean;
  experience?: string;
  created_at: string;
  updated_at: string;
}

export const useHosts = (searchTerm?: string) => {
  return useQuery({
    queryKey: ['hosts', searchTerm],
    queryFn: async (): Promise<Host[]> => {
      console.log('🏠 Fetching hosts from Supabase...');
      
      let query = supabase
        .from('hosts')
        .select('*')
        .order('name', { ascending: true });

      if (searchTerm && searchTerm.trim() !== '') {
        query = query.ilike('name', `%${searchTerm}%`);
      }

      const { data: hosts, error } = await query;

      if (error) {
        console.error('Error fetching hosts:', error);
        throw error;
      }

      console.log(`✅ Fetched ${hosts?.length || 0} hosts from Supabase`);
      return hosts || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
